import { Stack, Typography } from "@mui/material";
import MyContactsView from "../../components/my-contacts/MyContactsView";
import FabEyeButton from "../../components/user-activity-fab/UserActivityFab";

const MyContactsPage = () => {
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2} mb={1}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: "primary.main",
            fontWeight: 700,
            fontSize: { xs: "1.6rem", sm: "2.2rem" },
            letterSpacing: 0.5,
            flexGrow: 1,
          }}
        >
          Braze data
        </Typography>
      </Stack>
      <MyContactsView />
      <FabEyeButton />
    </>
  );
};

export default MyContactsPage;
